module.exports = __webpack_public_path__ + "static/media/icon_workboard_save.eb4c76ca.svg";